import { IParamsApi } from '@/types/apis/params';
import {
  BannerStatus,
  CutOffTimeTypes,
  ItemConditionEnum,
  Plan,
  PrefixIconColorKeys,
  PrefixIconSizeKeys,
  ShopifyPlan,
} from './enum';

export const LIST_PLUS_PLANS: string[] = [ShopifyPlan.PLUS, ShopifyPlan.PARTNER_SANDBOX, 'Shopify Plus'];

export const LIST_PLANS_ACTIVE_CHECKOUT_ACTIONS: string[] = [...LIST_PLUS_PLANS, ShopifyPlan.PARTNER_TEST];

export const REST_OF_THE_WORLD = 'restOfWorld';

export const dataSampleLayout = [
  {
    text_color: '#907366',
    icon_color: '#907366',
    text_size: 13,
    background_color: '#FFFFFF',
    border_color: '#907366',
    text: '🚀 Text',
  },
  {
    text_color: '#FEAE78',
    icon_color: '#FEAE78',
    text_size: 13,
    background_color: '#FFFFFF',
    border_color: '#FEAE78',
    text: '🚚 Text',
  },
  {
    text_color: '#689DE0',
    icon_color: '#689DE0',
    text_size: 13,
    background_color: '#FFFFFF',
    border_color: '#689DE0',
    text: '🛳️ Text',
  },
  {
    text_color: '#84CECD',
    icon_color: '#84CECD',
    text_size: 13,
    background_color: '#FFFFFF',
    border_color: '#84CECD',
    text: '🛵 Text',
  },
  {
    text_color: '#F182BA',
    icon_color: '#F182BA',
    text_size: 13,
    background_color: '#FFF4F4',
    border_color: '#F182BA',
    text: '🚚 Text',
  },
  {
    text_color: '#5788BA',
    icon_color: '#5788BA',
    text_size: 13,
    background_color: '#E5FFFA',
    border_color: '#80F0FD',
    text: '🚅 Text',
  },
  {
    text_color: '#97BB72',
    icon_color: '#97BB72',
    text_size: 13,
    background_color: '#FCFFDD',
    border_color: '#C6E45B',
    text: '🚛 Text',
  },
  {
    text_color: '#E8AA6C',
    icon_color: '#E8AA6C',
    text_size: 13,
    background_color: '#FFF4E6',
    border_color: '#FFD66C',
    text: '🚂 Text',
  },
  {
    text_color: '#CF94FE',
    icon_color: '#CF94FE',
    text_size: 13,
    background_color: '#FFEFFE',
    border_color: '#D67CFF',
    text: '🚀 Text',
  },
];

export const delayDebounce = 500;

export const stickyTopCreate = 58;

export const stickyTopCreateCheckoutRule = 68;

export const stickyTop = 0;

export const stickyTopOnboarding = 94;

export const limitPlan = {
  generalRule: {
    free: 1,
    standard: 3,
  },
  specificRule: {
    free: 1,
    standard: 2,
  },
  targetPerRule: {
    free: 1,
    standard: 3,
  },
  zipcodePerRule: {
    free: 1,
    standard: 3,
  },
  countryPerRule: {
    free: 1,
    standard: 3,
  },
  regionPerRule: {
    free: 0,
    standard: 3,
  },
};

export const prefixIconSizes = {
  [PrefixIconSizeKeys.base]: '14',
  [PrefixIconSizeKeys.extraSmall]: '10',
  [PrefixIconSizeKeys.small]: '12',
  [PrefixIconSizeKeys.large]: '18',
};

export const prefixIconColors = {
  [PrefixIconColorKeys.base]: '#707070',
  [PrefixIconColorKeys.accent]: '#1773B0',
  [PrefixIconColorKeys.critical]: '#DE2A2B',
  [PrefixIconColorKeys.decorative]: '#1773B0',
  [PrefixIconColorKeys.info]: '#0F1010',
  [PrefixIconColorKeys.interactive]: '#1773B0',
  [PrefixIconColorKeys.monochrome]: '#111113',
  [PrefixIconColorKeys.subdued]: '#787879',
  [PrefixIconColorKeys.success]: '#57825B',
  [PrefixIconColorKeys.warning]: '#957210',
};

export const bannerTitleColors = {
  [BannerStatus.success]: '#101E11',
  [BannerStatus.info]: '#1C1C1C',
  [BannerStatus.warning]: '#241700',
  [BannerStatus.critical]: '#420000',
};

export const newLimitPlan = {
  [Plan.FREE]: {
    maxRule: 1,
    maxCountry: 1,
    maxState: 0,
    maxZipcode: 1,
    itemConditon: 0,
    canAddItemConditon: false,
    canAddState: false,
    maxLanguage: 0,
  },
  [Plan.STANDARD]: {
    maxRule: 3,
    maxCountry: 3,
    maxState: 3,
    maxZipcode: 3,
    itemConditon: 3,
    canAddItemConditon: true,
    canAddState: true,
    maxLanguage: 3,
  },
};

export const initWeekWorkingDays: IParamsApi.IWeekWorkingDays = {
  [CutOffTimeTypes.Delivery]: [
    { enable: 1, cut_off_after: '23:59', day: 0 },
    { enable: 1, cut_off_after: '23:59', day: 1 },
    { enable: 1, cut_off_after: '23:59', day: 2 },
    { enable: 1, cut_off_after: '23:59', day: 3 },
    { enable: 1, cut_off_after: '23:59', day: 4 },
    { enable: 1, cut_off_after: '23:59', day: 5 },
    { enable: 1, cut_off_after: '23:59', day: 6 },
  ],
  [CutOffTimeTypes.Prepare]: [
    { enable: 1, cut_off_after: '23:59', day: 0 },
    { enable: 1, cut_off_after: '23:59', day: 1 },
    { enable: 1, cut_off_after: '23:59', day: 2 },
    { enable: 1, cut_off_after: '23:59', day: 3 },
    { enable: 1, cut_off_after: '23:59', day: 4 },
    { enable: 1, cut_off_after: '23:59', day: 5 },
    { enable: 1, cut_off_after: '23:59', day: 6 },
  ],
  [CutOffTimeTypes.PrepareAndDelivery]: [
    { enable: 1, cut_off_after: '23:59', day: 0 },
    { enable: 1, cut_off_after: '23:59', day: 1 },
    { enable: 1, cut_off_after: '23:59', day: 2 },
    { enable: 1, cut_off_after: '23:59', day: 3 },
    { enable: 1, cut_off_after: '23:59', day: 4 },
    { enable: 1, cut_off_after: '23:59', day: 5 },
    { enable: 1, cut_off_after: '23:59', day: 6 },
  ],
};

export const conditionsToShowException = [
  ItemConditionEnum.IncludeCollection,
  ItemConditionEnum.ExcludeCollection,
  ItemConditionEnum.IncludeVendor,
  ItemConditionEnum.ExcludeVendor,
  ItemConditionEnum.IncludeProductTag,
  ItemConditionEnum.ExcludeProductTag,
  // ItemConditionEnum.IncludeInventoryLocation,
  // ItemConditionEnum.ExcludeInventoryLocation,
  // ItemConditionEnum.IncludeProductMetafield,
  // ItemConditionEnum.ExcludeProductMetafield,
  // ItemConditionEnum.IncludeVariantMetafield,
  // ItemConditionEnum.ExcludeVariantMetafield,
];

export const errorFieldTypeRuleConfig = {
  [ItemConditionEnum.ExcludeProduct]: 'product',
  [ItemConditionEnum.IncludeProduct]: 'product',
  [ItemConditionEnum.ExcludeCollection]: 'collection',
  [ItemConditionEnum.IncludeCollection]: 'collection',
  [ItemConditionEnum.ExcludeVendor]: 'vendor',
  [ItemConditionEnum.IncludeVendor]: 'vendor',
  [ItemConditionEnum.ExcludeSKU]: 'skus',
  [ItemConditionEnum.IncludeSKU]: 'skus',
  [ItemConditionEnum.InventoryQuantity]: 'inventoryQuantity',
  [ItemConditionEnum.Exception]: 'exceptionProduct',
  [ItemConditionEnum.ExcludeProductTag]: 'productTags',
  [ItemConditionEnum.IncludeProductTag]: 'productTags',
  // [ItemConditionEnum.ExcludeInventoryLocation]: 'inventoryLocations',
  // [ItemConditionEnum.IncludeInventoryLocation]: 'inventoryLocations',
  // [ItemConditionEnum.ExcludeProductMetafield]: 'productMetafield',
  // [ItemConditionEnum.IncludeProductMetafield]: 'productMetafield',
  // [ItemConditionEnum.ExcludeVariantMetafield]: 'variantMetafield',
  // [ItemConditionEnum.IncludeVariantMetafield]: 'variantMetafield',
};

export const defaultDaySchedules = [
  { enable: false, weekday: 0, startTime: '00:00', endTime: '23:59' },
  { enable: true, weekday: 1, startTime: '00:00', endTime: '23:59' },
  { enable: true, weekday: 2, startTime: '00:00', endTime: '23:59' },
  { enable: true, weekday: 3, startTime: '00:00', endTime: '23:59' },
  { enable: true, weekday: 4, startTime: '00:00', endTime: '23:59' },
  { enable: true, weekday: 5, startTime: '00:00', endTime: '23:59' },
  { enable: false, weekday: 6, startTime: '00:00', endTime: '23:59' },
];

export const LIST_PLAN_ENABLE_LIFETIME = [Plan.PRO];
